import { HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { delay, mergeMap, retryWhen } from 'rxjs/operators';
import { ContactFieldListQueryParams } from '../../models/eloqua';

/**
 * @deprecated Use '../utils/client-utils/delayedRetry' instead
 * @param delayMs
 * @param maxRetry
 */
export function delayedRetry(delayMs: number, maxRetry: number) {
    let retries = maxRetry;

    return (src: Observable<any>) =>
        src.pipe(
            retryWhen((errors: Observable<any>) =>
                errors.pipe(
                    delay(delayMs),
                    mergeMap(error => (retries-- > 0 ? of(error) : throwError(error)))
                )
            )
        );
}

export function addAdditionalParams(httpOptionParams: HttpParams, additionalParams: ContactFieldListQueryParams): HttpParams {
    return Object.keys(additionalParams).reduce((params, key) => {
        const value = additionalParams[key as keyof ContactFieldListQueryParams];

        if (Array.isArray(value)) {
            // For array values, append each item to the existing params.
            return value.reduce((p, arrayValue) => p.append(key, arrayValue), params);
        } else if (value !== undefined && value !== null) {
            // For non-array values, set the value on the existing params.
            return params.set(key, value);
        }

        return params;
    }, httpOptionParams);
}
